import { Component } from '@angular/core';
import { ActivatedRoute, Data, Params } from '@angular/router';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { DynamicTableCellsParserService } from './services/dynamic-table-cells-parser.service';
import { DynamicListContent } from 'src/app/services/application-resources/models/page-resource-content';
import { Observable, combineLatest } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MenuItem } from 'src/app/components/dropdown-menu/dropdown-menu.component';
import { MenuItemModelParserService } from './services/menu-item-model-parser.service';
import { getDataUrl } from 'src/app/helpers/get-data-url';

@Component({
    templateUrl: './dynamic-list-2.component.html',
    selector: 'dynamic-list-2',
    standalone: false
})
export class DynamicList2Component {
  private routeParams$: Observable<Params>;
  private queryParams$: Observable<Params>;
  private routeData$: Observable<Data>;

  public onInit$: Observable<[Params, Params, Data]>;
  constructor(
    private route: ActivatedRoute,
    private dynamicTableCellsParserService: DynamicTableCellsParserService,
    private menuItemModelParserService: MenuItemModelParserService
  ) {
    this.routeParams$ = this.route.params;
    this.queryParams$ = this.route.queryParams;
    this.routeData$ = this.route.data;

    this.onInit$ = combineLatest([
      this.routeParams$,
      this.queryParams$,
      this.routeData$,
    ]).pipe(tap((options) => this.initialize(options)));
  }

  title: string;
  wrapperClass: string = 'container-single views-container';
  tableClass: string = '';
  tableProps?: CardListCell[];
  itemsPerPage?: number;
  sourceUrl: string;
  dynamicTableSettings?: DynamicListContent;
  serverType: string;
  menuItems?: MenuItem[];
  showSearch: boolean = false;

  private initialize(options: [Params, Params, Data]) {
    const [routeParams, queryParams, routeData] = options;
    this.dynamicTableSettings = routeData as DynamicListContent;

    this.title = this.dynamicTableSettings.title;
    this.itemsPerPage = this.dynamicTableSettings.itemsPerPage;
    
    this.showSearch = this.dynamicTableSettings.searchField ? true : false;

    if (this.dynamicTableSettings.wrapperClass)
      this.wrapperClass = this.dynamicTableSettings.wrapperClass;

    if (this.dynamicTableSettings.tableClass)
      this.tableClass = this.dynamicTableSettings.tableClass;

    if (this.dynamicTableSettings.serverType)
      this.serverType = this.dynamicTableSettings.serverType;
    
    this.tableProps = this.dynamicTableCellsParserService.parse(
      this.dynamicTableSettings.cols
    );
    
    let parameters: Params = {};
    Object.assign(parameters, routeParams);
    Object.assign(parameters, queryParams);
    
    this.sourceUrl = getDataUrl(parameters, this.dynamicTableSettings.dataUrl);

    if (this.dynamicTableSettings.menuItemModels)
      this.menuItems = this.dynamicTableSettings.menuItemModels.map(
        (menuItemModel) =>
          this.menuItemModelParserService.parse(menuItemModel, parameters)
      );
  }
}
